// removed by extract-text-webpack-plugin
module.exports = {"taskTemplateListDetailsBlock":"TaskTemplateListDetailsBlock__taskTemplateListDetailsBlock__1hmKt","column":"TaskTemplateListDetailsBlock__column__D2Oz5","chip":"TaskTemplateListDetailsBlock__chip__1cL7v","deeplink":"TaskTemplateListDetailsBlock__deeplink__Q_Knj","icon":"TaskTemplateListDetailsBlock__icon__322QN","text":"TaskTemplateListDetailsBlock__text__1W9F-","attachment":"TaskTemplateListDetailsBlock__attachment__2195a","role":"TaskTemplateListDetailsBlock__role__24fZS"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Pages/TaskTemplateListOverview/TaskTemplateListView/TaskTemplateListCard/TaskTemplateListDetailsBlock/TaskTemplateListDetailsBlock.scss
// module id = 1935
// module chunks = 0